module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-row', {
    staticClass: "content-bottom-padded",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('shop-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "distributors": "",
      "shopIdDefault": _vm.params.distributor_id
    },
    on: {
      "update": _vm.storeSearch
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "clearable": "",
      "placeholder": "请选择分类"
    },
    model: {
      value: (_vm.params.merchant_category_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "merchant_category_id", $$v)
      },
      expression: "params.merchant_category_id"
    }
  }, [_c('el-option', {
    key: 0,
    attrs: {
      "value": 0,
      "label": "未分类"
    }
  }), _vm._v(" "), _vm._l((_vm.categoryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.category_name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini",
      "placeholder": "请输入商品名称或者货号"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsNumberSearch
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), (_vm.params.distributor_id) ? _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-upload"
    },
    on: {
      "click": function($event) {
        return _vm.syncGoodsPrice()
      }
    }
  }, [_vm._v("同步商品价格\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-upload"
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchOnline(true)
      }
    }
  }, [_vm._v("批量上架\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        return _vm.handleBatchOnline(false)
      }
    }
  }, [_vm._v("批量下架\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.addCategories
    }
  }, [_vm._v("批量关联分类")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleBatchDownload
    }
  }, [_vm._v("商品码下载")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-delete"
    },
    on: {
      "click": function($event) {
        return _vm.delItemsAction(true)
      }
    }
  }, [_vm._v("刪除勾选商品")])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      ref: "multipleItemsTable",
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.list,
        "height": _vm.wheight - 240
      },
      on: {
        "selection-change": _vm.handleItemsSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "width": "45"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.handleSkuEdit(scope.row)
              }
            }
          }, [_vm._v("设置SKU")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "上下架操作",
        "width": "90"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            on: {
              "change": function($event) {
                return _vm.switchStatusChange(scope.$index, scope.row, true)
              }
            },
            model: {
              value: (scope.row.is_can_sale),
              callback: function($$v) {
                _vm.$set(scope.row, "is_can_sale", $$v)
              },
              expression: "scope.row.is_can_sale"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_bn",
        "label": "商品货号",
        "min-width": "50"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n            " + _vm._s(scope.row.item_bn) + "\n          ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名称",
        "min-width": "160"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_bn",
        "label": "商品图片"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('img', {
            staticStyle: {
              "width": "50px"
            },
            attrs: {
              "src": scope.row.pics[0],
              "alt": ""
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "店铺分类",
        "min-with": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(_vm._s(scope.row.category_name ? scope.row.category_name : '未分类'))]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "关联分类",
        "min-with": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.addCategories(scope.row)
              }
            }
          }, [_vm._v("编辑关联分类")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "price",
        "label": "商品价格",
        "min-width": "60"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n            " + _vm._s(scope.row.price) + "元\n          ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "库存",
        "min-width": "60"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n            " + _vm._s(scope.row.store) + "\n          ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "打包费",
        "min-width": "60"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n            " + _vm._s(scope.row.packing_fee) + "元\n          ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "搜索推荐"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-value": 1,
              "inactive-value": 0
            },
            on: {
              "change": function($event) {
                return _vm.switchStatusChange(scope.$index, scope.row, true)
              }
            },
            model: {
              value: (scope.row.search_recommend),
              callback: function($$v) {
                _vm.$set(scope.row, "search_recommend", $$v)
              },
              expression: "scope.row.search_recommend"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "approve_status",
        "label": "状态",
        "min-width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.approve_status === 'onsale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 前台可销售")]) : (scope.row.approve_status === 'offline_sale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 可线下销售")]) : _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 不可销售")])]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-padded content-center"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('sideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": "编辑店铺sku配置",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_vm._t("default", function() {
    return [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.itemSkuList,
        "height": _vm.wheight - 240
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "item_id",
        "width": "80",
        "label": "商品ID"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_bn",
        "label": "商品货号",
        "width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n            " + _vm._s(scope.row.item_bn) + "\n          ")]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_name",
        "label": "商品名称",
        "width": "180"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "price",
        "label": "商品价格",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.item_id !== _vm.currentId) ? _c('div', [_vm._v("\n              ¥" + _vm._s(scope.row.price / 100) + "\n              "), _c('i', {
            staticClass: "el-input__icon el-icon-edit",
            on: {
              "click": function($event) {
                return _vm.editPrice(scope.row.item_id, scope.row.price)
              }
            }
          })]) : _c('el-input', {
            ref: 'input_' + scope.row.item_id,
            attrs: {
              "size": "mini"
            },
            on: {
              "blur": function($event) {
                return _vm.handleBlur(scope.$index, scope)
              }
            },
            model: {
              value: (_vm.currentPrice),
              callback: function($$v) {
                _vm.currentPrice = $$v
              },
              expression: "currentPrice"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "item_spec_desc",
        "label": "规格",
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "store",
        "label": "库存",
        "width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(_vm.editStore) ? _c('el-input', {
            model: {
              value: (scope.row.store),
              callback: function($$v) {
                _vm.$set(scope.row, "store", $$v)
              },
              expression: "scope.row.store"
            }
          }, [_c('i', {
            staticClass: "el-input__icon el-icon-edit",
            attrs: {
              "slot": "suffix"
            },
            slot: "suffix"
          })]) : _c('el-input', {
            attrs: {
              "disabled": ""
            },
            model: {
              value: (scope.row.store),
              callback: function($$v) {
                _vm.$set(scope.row, "store", $$v)
              },
              expression: "scope.row.store"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "approve_status",
        "label": "状态",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.approve_status === 'onsale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 前台可销售")]) : (scope.row.approve_status === 'offline_sale') ? _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 可线下销售")]) : _c('div', {
            staticClass: "grid-content"
          }, [_vm._v(" 不可销售")])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "上下架操作",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-text": "已上架",
              "inactive-text": "已下架"
            },
            on: {
              "change": function($event) {
                return _vm.switchStatusChange(scope.$index, scope.row, false)
              }
            },
            model: {
              value: (scope.row.is_can_sale),
              callback: function($$v) {
                _vm.$set(scope.row, "is_can_sale", $$v)
              },
              expression: "scope.row.is_can_sale"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "更新库存",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            attrs: {
              "type": "primary",
              "size": "mini"
            },
            on: {
              "click": function($event) {
                return _vm.saveStore(scope.row.store, scope.row)
              }
            },
            model: {
              value: (scope.row.store),
              callback: function($$v) {
                _vm.$set(scope.row, "store", $$v)
              },
              expression: "scope.row.store"
            }
          }, [_vm._v("更新库存")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "primary",
              "size": "mini"
            },
            on: {
              "click": function($event) {
                return _vm.syncStore(scope.row.store, scope.row)
              }
            },
            model: {
              value: (scope.row.store),
              callback: function($$v) {
                _vm.$set(scope.row, "store", $$v)
              },
              expression: "scope.row.store"
            }
          }, [_vm._v("同步OMS库存")])]
        }
      }])
    })], 1)]
  })], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.addCategoryTitle,
      "visible": _vm.addCategoryVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addCategoryVisible = $event
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "palceholder": "请选择"
    },
    model: {
      value: (_vm.form.items_category_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "items_category_ids", $$v)
      },
      expression: "form.items_category_ids"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.category_name,
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addCategoryVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addCategorySubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.titleSet,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [(_vm.form.cancel == true) ? _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.category_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "category_ids", $$v)
      },
      expression: "form.category_ids"
    }
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.category_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1) : _c('div', [_vm._v("请确认您要删除已有分类?")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6f8170cb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8170cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/relmalllist.vue
// module id = 2810
// module chunks = 0